import { render } from "./product-card-link.vue?vue&type=template&id=09f3ddb5"
import script from "./product-card-link.vue?vue&type=script&lang=js"
export * from "./product-card-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__